import { useEffect } from 'react'
import { useReviewer } from '../api'
import { useUserStore } from './use-user-store'

export const useSetReviewerInfo = () => {
  const { userInfo, setIsOnshore } = useUserStore()
  const {
    isLoading,
    isSuccess,
    data: reviewer,
  } = useReviewer(userInfo?.email as string | undefined)

  useEffect(() => {
    if (isSuccess) {
      setIsOnshore(reviewer && !reviewer.is_offshore_user)
    }
    // Make sure we only run this effect when the response is successful
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess])

  return {
    isLoading,
  }
}
